"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntroEyeCatcher = void 0;

var react_1 = __importDefault(require("react"));

var elements_1 = require("../../elements");

var IntroEyeCatcher = function IntroEyeCatcher(_a) {
  var contentTop = _a.contentTop,
      contentBottom = _a.contentBottom,
      _b = _a.shadow,
      shadow = _b === void 0 ? false : _b,
      theme = _a.theme,
      elementId = _a.elementId,
      cssStyle = _a.cssStyle;
  var style = "m-auto w-10/12 md:w-3/4 text-center " + (theme ? theme.body.backgroundColor : 'bg-gray-100') + " " + (theme ? theme.body.textColor : 'text-gray-800') + " overflow-hidden " + (shadow ? 'shadow-lg' : '') + " " + (cssStyle ? cssStyle : '');
  return react_1["default"].createElement("header", {
    className: style,
    id: elementId
  }, react_1["default"].createElement(elements_1.Hruler, {
    theme: theme
  }), react_1["default"].createElement(elements_1.TitleSub, {
    theme: theme
  }, contentTop), react_1["default"].createElement(elements_1.Hruler, {
    theme: theme
  }), contentBottom && contentBottom.length > 0 && react_1["default"].createElement(elements_1.TextLead, {
    theme: theme
  }, contentBottom));
};

exports.IntroEyeCatcher = IntroEyeCatcher;